export const isMatchedAssetsRequestReady = ({ pathname, request }) =>
  Boolean(request?.params) && request?.pathname === pathname;
